import { useState } from "react";
import classnames from "classnames";
import BreadCrumb from "components/common/BreadCrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { getDocumentTitle } from "utils/helpers";
import WorkAssignmentCalendarView from "./WorkAssignmentCalendarView";
import WorkAssignmentTableView from "./WorkAssignmentTableView";

type ViewMode = "calendar" | "table";

const AssignmentsPage = () => {
  document.title = getDocumentTitle("Assignments");

  const [view, setView] = useState<ViewMode>("calendar");

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Assignments" pageTitle="Operations" />

        <Card>
          <CardHeader className="border-0 pb-0">
            <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
              <h5 className="card-title mb-0">Assignments</h5>

              <div
                className="btn-group btn-group-sm"
                role="group"
                aria-label="View mode"
              >
                <button
                  type="button"
                  className={classnames("btn", {
                    "btn-primary": view === "calendar",
                    "btn-outline-secondary": view !== "calendar",
                  })}
                  onClick={() => setView("calendar")}
                  title="Calendar view"
                >
                  <i className="ri-calendar-2-line me-1" />
                  Calendar
                </button>
                <button
                  type="button"
                  className={classnames("btn", {
                    "btn-primary": view === "table",
                    "btn-outline-secondary": view !== "table",
                  })}
                  onClick={() => setView("table")}
                  title="List view"
                >
                  <i className="ri-list-check me-1" />
                  List
                </button>
              </div>
            </div>
          </CardHeader>

          <CardBody className={view === "table" ? "pt-0" : undefined}>
            {view === "calendar" ? <WorkAssignmentCalendarView /> : <WorkAssignmentTableView />}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AssignmentsPage;
